class NotificationCenterCtrl {
    constructor(NotificationCenterApi, openAppointmentService, $rootScope) {
        'ngInject';

        this.NotificationCenterApi = NotificationCenterApi;
        this.openAppointmentService = openAppointmentService;
        this.$rootScope = $rootScope;
        this.notifications = [];
    }

    $onInit() {
        this._loadNotifications();
        this._deregisterRefresh = this.$rootScope.$on('notifications:refresh', () => this._loadNotifications());
    }

    $onDestroy() {
        if (this._deregisterRefresh) this._deregisterRefresh();
    }

    _loadNotifications() {
        this.NotificationCenterApi.getNotifications()
            .then(notifications => {
                this.notifications = notifications;
            });
    }

    executeAction(action) {
        switch (action.type) {
            case 'OPEN_APPOINTMENT':
                this.openAppointmentService.openAppointment(action.appointmentId, true);
                break;
        }
    }

    getActionLabel(action) {
        var labels = {
            'OPEN_APPOINTMENT': 'Bevestig'
        };
        return labels[action.type] || '';
    }
}

(function () {
    'use strict';

    angular.module('doclr.components')
        .directive('notificationCenter', () => ({
            restrict: 'E',
            replace: true,
            templateUrl: '/partials/components/notificationcenter/notificationcenter.component.html',
            controller: NotificationCenterCtrl,
            controllerAs: 'ctrl'
        }));

})();